import * as React from "react";
import styles from "./CurrencyCell.module.scss";
export interface ICurrencyCellProps {
	value?: number;
	decimalPlaces?: number;
	currency?: string;
}

export function CurrencyCell({ value = 0, decimalPlaces = 2, currency = "$" }: ICurrencyCellProps) {
	return (
		<div className={styles.currencyCell}>
			<div className={styles.currency}>{currency}</div>
			<div className={styles.value}>{value.toFixed(decimalPlaces)}</div>
		</div>
	);
}
